import React from 'react';
import { Box, Flex, Badge, Text, IconButton, Tooltip, HStack } from '@chakra-ui/react';
import { RepeatIcon, TimeIcon } from '@chakra-ui/icons';

function getCardColors(passRate) {
  if (passRate >= 90) return { bg: 'green.50', border: 'green.200', color: 'green.700' };
  if (passRate >= 70) return { bg: 'yellow.50', border: 'yellow.200', color: 'yellow.700' };
  return { bg: 'red.50', border: 'red.200', color: 'red.700' };
}

function getCardHoverColor(passRate) {
  if (passRate >= 90) return 'green.300';
  if (passRate >= 70) return 'yellow.300';
  if (passRate >= 0) return 'red.300';
  return 'blue.300';
}

const TestGroupCard = ({ group, metrics, tests = [], onView, onRunAll, onHistory }) => {
  const passRate = Number(metrics.passRate);
  const { bg, border, color } = getCardColors(passRate);
  const borderHover = getCardHoverColor(passRate);

  return (
    <Box
      onClick={onView}
      cursor="pointer"
      bg={bg}
      borderRadius="xl"
      boxShadow="sm"
      borderWidth="2px"
      borderColor={border}
      p={5}
      minW={{ base: '140px', md: '180px' }}
      minH="110px"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      transition="border-color 0.2s, box-shadow 0.2s"
      _hover={{ borderColor: borderHover, boxShadow: 'md', filter: 'brightness(0.98)' }}
      tabIndex={0}
      role="button"
      outline="none"
      _focus={{ boxShadow: 'outline', borderColor: borderHover }}
      mb={2}
      onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onView(); } }}
    >
      {/* Group Name */}
      <Text fontSize="md" fontWeight="bold" color={color} mb={1} noOfLines={1} textAlign="center">{group}</Text>
      {/* Pass Rate */}
      <Text fontSize="2xl" fontWeight="extrabold" color={color} mb={2} textAlign="center">{Number(metrics.passRate).toFixed(1)}%</Text>
      {/* Badges */}
      <HStack spacing={2} mb={2}>
        <Badge colorScheme="green" fontSize="xs">P: {metrics.passed}</Badge>
        <Badge colorScheme="red" fontSize="xs">F: {metrics.failed}</Badge>
        <Badge colorScheme="yellow" fontSize="xs">S: {metrics.skipped}</Badge>
      </HStack>
      {/* Last Run */}
      <Text fontSize="xs" color="gray.500" mb={2} textAlign="center">{metrics.lastRun ? new Date(metrics.lastRun).toLocaleString() : '-'}</Text>
      {/* Actions */}
      <Flex align="center" gap={1} mt="auto">
        <Tooltip label="Feature coming soon">
          <IconButton icon={<RepeatIcon />} onClick={e => { e.stopPropagation(); }} aria-label="Run All" isLoading={false} tabIndex={0} isDisabled={true} />
        </Tooltip>
        <Tooltip label="Feature coming soon">
          <IconButton icon={<TimeIcon />} onClick={e => { e.stopPropagation(); }} aria-label="View History" tabIndex={0} isDisabled={true} />
        </Tooltip>
      </Flex>
    </Box>
  );
};

export default TestGroupCard; 